<template>
    <generic-view
        entity_name="language"
        title = "Languages"
        :headers="headers"
        icon="mdi-flag"
    >
    </generic-view>
</template>
<script>
import GenericView from './GenericView'
export default {
    data(){
        return {
            headers:[
                {
                    text: 'Code',
                    value: 'code',
                    type: 'textfield'
                },
                {
                    text: 'Description',
                    value: 'description',
                    type: 'textfield'
                },
            ]
        }
    },
    components:{GenericView}
    
}
</script>